module.exports = __webpack_public_path__ + "media/images/promo-receptionist-3bdd020e73b02af9de50b377114ee7cb.png";